import { render, staticRenderFns } from "./divider-primary.vue?vue&type=template&id=6aa2be6b&scoped=true"
import script from "./divider-primary.vue?vue&type=script&lang=js"
export * from "./divider-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa2be6b",
  null
  
)

export default component.exports